import types from './actionsTypes';

const initialState = {
  history: [],
};

export default function appReducer(state = initialState, action) {
  switch (action.type) {
    case types.SET_HISTORY:
      return {
        ...state,
        history: action.payload,
      };
    default:
      return state;
  }
}
